<template>
  <div id="app" v-cloak>
    <router-view/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'App',
  components: {},
  computed: {
    ...mapGetters(['getLanguage']),
  },
  watch: {
    getLanguage: function (val, oldVal) {
      this.$i18n.locale = val;
      window.location.reload()
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/css/base.scss';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

[v-cloak] {
  display: none;
}
</style>
